import { Box } from '@hivebrite/design-system/Box';

import {
  BUTTON_COLOR_MODE,
  type StyleChildProps,
} from 'hb-builder/components/BuilderComponents/block/Strips/types/props';
import RadiosInput from 'hb-builder/components/common/SettingsLibrary/ComposedInputs/RadiosInput';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import {
  BUTTON_MODE_OPTIONS,
  type ButtonItemAttributes,
} from 'hb-react/backoffice/types/builder/itemAttributes/buttonItemAttributes';

import ButtonsSettings from './ButtonsSettings';
import { getColorModeOptions } from '../utils/constants';

interface ButtonProps extends StyleChildProps {
  buttons: DocumentItem<ButtonItemAttributes>[];
}

const Button = ({
  buttons,
  handleBulkChange,
  item,
  onChange,
  parentItem,
}: ButtonProps) => {
  // RadioInput option values must be unique on a page,
  // so we added the name of the item as an identifier
  const optionPrefix = 'button-';

  const handleColorModeChange = (value: string) => {
    const finalValue = value.replace(optionPrefix, '');

    const isAtLeastOneButtonCustom = buttons.some(
      (button) => button.attributes?.mode === BUTTON_MODE_OPTIONS.CUSTOM,
    );

    // If at least one button is custom and the color mode is set to same,
    // we need to change the mode of all buttons to custom to be able to edit them all at once
    // and so that none of them are "stuck" in the "network" mode
    if (isAtLeastOneButtonCustom && finalValue === BUTTON_COLOR_MODE.SAME) {
      handleBulkChange({
        element: 'button',
        settingKey: 'attributes.mode',
        value: BUTTON_MODE_OPTIONS.CUSTOM,
      });
    }

    onChange({
      id: parentItem.id,
      settingKey: 'attributes.buttonColorMode',
      value: finalValue,
    });
  };

  return (
    <>
      <Box mt="6px" mb={6}>
        <RadiosInput
          direction="horizontal"
          name={`${optionPrefix}color-mode`}
          onChange={handleColorModeChange}
          options={getColorModeOptions({ optionPrefix })}
          value={`${optionPrefix}${
            parentItem.attributes?.buttonColorMode || BUTTON_COLOR_MODE.SAME
          }`}
        />
      </Box>
      <ButtonsSettings
        buttons={buttons}
        handleBulkChange={handleBulkChange}
        item={item}
        onChange={onChange}
        parentItem={parentItem}
      />
    </>
  );
};

export default Button;
